export default __webpack_public_path__ + "static/media/gw200-4.89877d8b.png";